module.exports = __webpack_public_path__ + "static/img_9832-d68abfabca4e22c16cb1d043ecdee7ad.webp";